import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { iusuario } from '../models/iusuario.model';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ImagenBase64 } from '../models/imagenBase64.model';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {

    constructor(private apiService: ApiService,
        private httpClient: HttpClient
    ) { }

    insertar_propiedad(data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + "usuario-propiedad", data, { observe: 'response' })
    }

    actualizar_propiedad(data: any): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "usuario-propiedad", data, { observe: 'response' })
    }

    eliminar_propiedad(codpro: number, coduser: string): Observable<any> {
        return this.httpClient.delete(environment.serviceUrl + "usuario-propiedad/" + codpro + "?coduser=" + coduser, { observe: 'response' })
    }


    obtener_propiedad(codpro: number, coduser: string): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/" + codpro + "?coduser=" + coduser, { observe: 'response' })
    }

    obtenerFirma_v2(id_cia:any,coduser:any,item?:any){
        this.apiService.setUrlPathReportes('usuario/'+id_cia+'/public/' + coduser + '/firma');
        let queryParams = '';
        if (item !== undefined) {
            queryParams = `?item=${item}`;
        }
        return this.apiService.execGetQueryJson(`?item=${item}`);
     }

    buscar_propiedad2(coduser: string, descri: any): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/buscar?coduser=" + coduser  + "&descri=" + encodeURIComponent(descri), { observe: 'response' })
    }

    buscar_propiedad(coduser: string): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/buscar?coduser=" + coduser, { observe: 'response' })
    }

    buscarAccesos(coduser: string, codmod: number): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario/" + coduser + "/accesos?codmod=" + codmod, { observe: 'response' })
    }


    logout(coduser: string): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "usuario/" + coduser + "/logout", null, { observe: 'response' })
    }

    insertarUsuario(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_insertar_url);
        return this.apiService.executePostJson(data).pipe();
    }

    obtenerUsuarios(coduser: string, nombres: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_buscar);
        return this.apiService.execGetQueryJson(`coduser=${coduser}&nombres=${encodeURI(nombres)}`)
    }

    obtener(coduser: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_obtener);
        return this.apiService.execGetQueryJson(`${coduser}`)
    }

    actualizar(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_actualizar);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_eliminar);
        return this.apiService.executeDeleteJson(data).pipe();
    }

    updatecontrasenia(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_cambiar_contra);
        return this.apiService.executePutJson(data).pipe();
    }
    /****************MANTENIMIENTO PERMISOS USUARIO*************************/

    /****guardar nuevo acceso*****/

    insertAcceso(coduser: any, data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + `usuario/${coduser}/accesos`, data, { observe: 'response' })
    }

    delete_acceso(coduser: any, codmod: any, codacc: any): Observable<any> {
        return this.httpClient.delete(environment.serviceUrl + `usuario/${coduser}/accesos/${codmod}/${codacc}`, { observe: 'response' })
    }


    /********Impresion contraseñas******** */

    imprimir_claves(coduser: any, nombres: any) {//sin descuento
        const fullUrl = environment.serviceUrl +ROUTES_ARCHIVOS.usuario_print+ `coduser=${coduser}&nombres=${encodeURI(nombres)}`;
        // const fullUrl = environment.serviceUrl + `cotizacion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.get(fullUrl, httpOptions);
    }
    /*******Mantenimiento modulos */
    insertModulos(sender:any){
    this.apiService.setUrlPathApi('usuario/modulos');
    return this.apiService.executePostJson(sender).pipe();
    }
    updateModulos(sender:any){
        this.apiService.executePutJson(`usuario/modulos`)
        return this.apiService.executePutJson(sender).pipe();
    }
    deleteModulos(coduser:any,codmod:any){
       this.apiService.setUrlPathApi(`usuario/modulos/${coduser}`);
       return this.apiService.executeDeleteJson(`?codmod=${codmod}`)
    }
    obtenerModulos(coduser:any,codmod:any){
      this.apiService.setUrlPathApi(`usuario/modulos/${coduser}`);
      return this.apiService.execGetQueryJson(`?codmod=${codmod}`);
    }
    buscarModulos(coduser:any,codmod:any,swacti:any){
        this.apiService.setUrlPathApi('usuario/modulos/buscar');
        return this.apiService.execGetQueryJson(`?coduser=${coduser}&codmod=${codmod}&swacti=${swacti}`);
    }

    actualizarImagenVendedor(coduser: string, imagenBase64: ImagenBase64): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        return this.apiService.executePutJson(imagenBase64).pipe();
    }

    deleteImagenVendedor(coduser: string, item?:number): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        let queryParams = '';
        if (item !== undefined) {
            queryParams = `?item=${item}`;
        }
        return this.apiService.executeDeleteJson(queryParams)
    }
}